export enum Lookup {
  RecordFound = 'AT.1',
  RecordNotFound = 'AT.0',
}
